/* eslint-disable array-callback-return */
import moment from "moment";

export const specialties = [
  "Pediatrician",
  "Obstetrician and Gynecologist",
  "Neurologist",
  "Ophthalmologist",
  "Otolaryngologist",
  "Dermatologist",
  "Cardiologist",
  "Chest Physician",
  "Gastroenterologist",
  "Urologist",
  "Orthopedic Surgeon",
  "Psychiatrist",
  "Dentist",
  "Gynecologist",
  "Obstetrician",
  "Family Medicine Physician",
  "Generalist",
  "Nutritionist",
  "Other",
];

export const getLastWeekDays = () => {
  const today = new Date();
  const days: string[] = [];

  for (let i = 0; i < 7; i++) {
    const day = new Date(today);
    day.setDate(today.getDate() - i);
    days.push(day.toLocaleDateString("en-US", { weekday: "short" }));
  }

  return days.reverse(); // Reverse the array to get the days in chronological order
};

export const monthsAbbreviated = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const daysAbbr = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function getLast12Months() {
  const today = new Date();
  const months: string[] = [];

  for (let i = 0; i < 12; i++) {
    const monthIndex = (today.getMonth() - i + 12) % 12; // Ensure monthIndex is within 0-11 range
    const monthAbbreviated = monthsAbbreviated[monthIndex];
    months.unshift(monthAbbreviated);
  }

  return months;
}

function getLast4Weeks() {
  const today: any = new Date();
  const startOfYear: any = new Date(today.getFullYear(), 0, 0);
  const diff = today - startOfYear;
  const oneWeekInMilliseconds = 1000 * 60 * 60 * 24 * 7;
  const weekNumber = Math.floor(diff / oneWeekInMilliseconds);

  //   this is 0-indexed
  return [
    weekNumber - 3 < 0 ? weekNumber + 49 : weekNumber - 3,
    weekNumber - 2 < 0 ? weekNumber + 50 : weekNumber - 2,
    weekNumber - 1 < 0 ? weekNumber + 51 : weekNumber - 1,
    weekNumber,
  ];
}

export const formalizeAggrData = ({
  period,
  data,
}: {
  period: "week" | "month" | "year";
  data: any;
}) => {
  if (period === "year") {
    const mnths = getLast12Months();
    const values = mnths?.map((month, ind) => ({
      count: 0,
      x_axis: month,
    }));
    data?.map((dd: any) => {
      const xx = values?.find(
        (val) => val?.x_axis === monthsAbbreviated[dd?.unit?.month - 1],
      );
      if (xx) {
        xx.count = dd?.totalAppointments;
        xx["year"] = dd?.unit?.year;
      }
    });
    return values;
  } else if (period === "week") {
    const values = getLastWeekDays()?.map((day, ind) => ({
      count: 0,
      x_axis: day,
    }));
    data?.map((dd: any) => {
      const xx = values?.find(
        (val) => val?.x_axis === daysAbbr[dd?.unit?.dayOfWeek - 1],
      );
      if (xx) {
        xx.count = dd?.totalAppointments;
      }
    });
    return values;
  } else if (period === "month") {
    const last4Wks = getLast4Weeks();
    const values = last4Wks?.map((wkNo, ind) => {
      return {
        count: 0,
        wkNo,
      };
    });
    data?.map((dd: any) => {
      const xx = values?.find((val) => val?.wkNo === dd?.unit?.week);
      if (xx) {
        xx.count = dd?.totalAppointments;
      }
    });
    const values_ = values?.map((val, ind) => ({
      count: val?.count,
      x_axis: `Wk ${ind + 1}`,
    }));

    return values_;
  }
};
export const isFutureDay = (date) => {
  const givenDate = moment(date);
  const currentDate = moment();

  return givenDate.isAfter(currentDate, "day");
};

export const isPastDay = (date) => {
  const givenDate = moment(date);
  const currentDate = moment();

  return givenDate.isBefore(currentDate, "day");
};

export const hourOfDay = [
  "12:00 am",
  "01:00 am",
  "02:00 am",
  "03:00 am",
  "04:00 am",
  "05:00 am",
  "06:00 am",
  "07:00 am",
  "08:00 am",
  "09:00 am",
  "10:00 am",
  "11:00 am",
  "12:00 pm",
  "01:00 pm",
  "02:00 pm",
  "03:00 pm",
  "04:00 pm",
  "05:00 pm",
  "06:00 pm",
  "07:00 pm",
  "08:00 pm",
  "09:00 pm",
  "10:00 pm",
  "11:00 pm",
];

export const initialStateValue = {
  name: "",
  phoneNumber: "",
  height: "",
  bloodGroup: "",
  bloodGenotype: "",
  gender: "",
  email: "",
  address: "",
  riskCategory: "",
  weight: "",
  dateOfBirth: undefined,
  dateRegistered: "",
  patientNotes: "",
};
export const updateStateValue = {
  patientId: "",
  name: "",
  phoneNumber: "",
  height: "",
  bloodGroup: "",
  bloodGenotype: "",
  gender: "",
  email: "",
  address: "",
  riskCategory: "",
  weight: "",
  dateOfBirth: undefined,
  dateRegistered: "",
  patientNotes: "",
};
export interface TPatient {
  name: string;
  phoneNumber: string;
  height: number | string;
  bloodGroup: string;
  bloodGenotype: string;
  gender: string;
  email: string;
  address: string;
  riskCategory: string;
  weight: number | string;
  dateOfBirth: any;
  doctorId?: string;
  dateRegistered?: Date;
  age?: number;
  patientNotes: string | undefined;
}

export const getAge = (dob: string): string => {
  if (!dob) return "Not found";

  const birth = new Date(dob);
  if (isNaN(birth.getTime())) return "Not found";

  const today = new Date();
  let years = today.getFullYear() - birth.getFullYear();
  let months = today.getMonth() - birth.getMonth();

  if (months < 0 || (months === 0 && today.getDate() < birth.getDate())) {
    years--;
    months += 12;
  }
  if (years === 0) {
    return months === 1 ? "1 month" : `${months} months`;
  } else if (years === 1) {
    return months > 0 ? `1 year, ${months} months` : "1 year";
  } else if (years === 2 && months === 0) {
    return "2 years";
  } else if (years < 2) {
    return `${years} years, ${months} months`;
  }

  return `${years} years`;
};

export const bodyPartsToHideForChildren = new Set([
  "MEN Reproductive System",
  "Abdomen",
  "Women",
  "Cardiorespiratory",
  "Women Reproductive System",
]);

export const normalizeDateTime = (date) => {
  const tzOffsetMin = date.getTimezoneOffset(); // Get offset in minutes
  date.setMinutes(date.getMinutes() - tzOffsetMin); // Subtract the offset
  return date.toISOString();
};
